// extracted by mini-css-extract-plugin
module.exports = {"container":"ellipsis_container__zW6VK","fl-ellipsis":"ellipsis_fl-ellipsis__KDve0"};